import clsx from 'clsx';
import { SearchIcon } from '../icons/search';

export const Search = (ps: {
  value: string;
  onSearch: (query: string) => void;
  size?: 'small' | 'large';
}) => (
  <div className={clsx(' flex items-center')}>
    <div
      className={clsx(
        'w-full pr-2 text-neutral-500 rounded-md flex items-center gap-2 border border-neutral-500 bg-white',
      )}>
      <input
        className={clsx(
          'text-xs bg-transparent flex-grow outline-none w-full',
          ps.size === 'small' ? 'p-1' : 'p-2',
        )}
        placeholder="Cerca"
        value={ps.value}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => ps.onSearch(e.target.value)}
      />
      <SearchIcon className="w-4 h-4 fill-neutral-400 stroke-neutral-400" />
    </div>
  </div>
);
